import { Card } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import { AutocompleteInput, FormDataConsumer, ReferenceInput, required, SelectInput, SimpleForm } from "react-admin";
import { FieldValues } from "react-hook-form";

import CustomDateTimeInput from "shared/components/inputs/CustomDateTimeInput";
import { FranceGroupTypeEnum } from "shared/enums/globalEnums";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";
import { dateValidation } from "./validations";
import CertificationRtePhase2SiteIdsInput from "./CertificationRtePhase2SiteIdsInput";

const DateInputWithValidation = ({ source }: { source: string }) => {
  return <CustomDateTimeInput source={source} validate={[dateValidation]} />;
};

const CertificationRtePhase2Form = ({ handleSubmit }: { handleSubmit: (values: FieldValues) => void }) => {
  return (
    <SimpleForm onSubmit={handleSubmit}>
      <ReferenceInput
        source="edr_id"
        label="EDR"
        reference={SiteResourcesEnum.Groups}
        filter={{ type: FranceGroupTypeEnum.rte_edr }}
      >
        <AutocompleteInput validate={[required()]} />
      </ReferenceInput>
      <CertificationRtePhase2SiteIdsInput />
      <SelectInput
        source="certification_type"
        choices={[
          { id: "fcr", name: "FCR" },
          { id: "afrr-fcr", name: "AFRR-FCR" },
        ]}
        validate={[required()]}
      />

      <FormDataConsumer>
        {({ formData }) => {
          if (!formData.certification_type) return <></>;
          const isFcr = formData.certification_type === "fcr";
          const isAfrrFcr = formData.certification_type === "afrr-fcr";

          return (
            <>
              <Card sx={{ width: "100%" }}>
                <CardContent sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2, width: "100%" }}>
                  {isFcr && <FcrDateInputs />}
                  {isAfrrFcr && <AfrrFcrDateInputs />}
                </CardContent>
              </Card>
            </>
          );
        }}
      </FormDataConsumer>
    </SimpleForm>
  );
};

export default CertificationRtePhase2Form;

const AfrrFcrDateInputs = () => {
  return (
    <>
      <DateInputWithValidation source="essai_1_start_date" />
      <DateInputWithValidation source="essai_1_end_date" />
      <DateInputWithValidation source="essai_2_start_date" />
      <DateInputWithValidation source="essai_2_end_date" />
      <DateInputWithValidation source="test_8h_start_date" />
      <DateInputWithValidation source="test_8h_end_date" />
    </>
  );
};

const FcrDateInputs = () => {
  return (
    <>
      <DateInputWithValidation source="essai_1_bis_start_date" />
      <DateInputWithValidation source="essai_1_bis_end_date" />
      <DateInputWithValidation source="essai_2_start_date" />
      <DateInputWithValidation source="essai_2_end_date" />
      <DateInputWithValidation source="essai_3_start_date" />
      <DateInputWithValidation source="essai_3_end_date" />
      <DateInputWithValidation source="essai_4_start_date" />
      <DateInputWithValidation source="essai_4_end_date" />
      <DateInputWithValidation source="essai_5_start_date" />
      <DateInputWithValidation source="essai_5_end_date" />
      <DateInputWithValidation source="test_8h_start_date" />
      <DateInputWithValidation source="test_8h_end_date" />
    </>
  );
};
